import React from 'react'
import { RadioButton, RadioButtonGroup } from 'material-ui/RadioButton'
import PropTypes from 'prop-types'
import css from './styles.css'

const radioButtonStyle = {
  button: { fontWeight: 'normal', width: '50px' },
  icon: { fill: 'rgb(117 117 117)' },
  input: { width: '65px' },
  largeLabel: {
    width: '70px',
    color: 'rgb(117 117 117)',
    fontWeight: 'normal',
    textAlign: 'left',
  },
  label: {
    color: 'rgb(117 117 117)',
    fontWeight: 'normal',
    textAlign: 'left',
  },
}

const EmailTextFilter = ({ handleRadioBtnSelect, radioDisabled, selectedRadioBtn }) => (
  <RadioButtonGroup
    className={css.emailTextFilterWrapper}
    defaultSelected="all"
    name="emailTextFilter"
    onChange={handleRadioBtnSelect}
    valueSelected={selectedRadioBtn}
  >
    <RadioButton
      disabled={radioDisabled}
      iconStyle={radioButtonStyle.icon}
      inputStyle={radioButtonStyle.input}
      label="All"
      labelStyle={radioButtonStyle.label}
      style={radioButtonStyle.button}
      value="all"
    />
    <RadioButton
      disabled={radioDisabled}
      iconStyle={radioButtonStyle.icon}
      label="Email Only"
      labelStyle={radioButtonStyle.largeLabel}
      style={radioButtonStyle.button}
      value="email"
    />
    <RadioButton
      disabled={radioDisabled}
      iconStyle={radioButtonStyle.icon}
      label="Text Only"
      labelStyle={radioButtonStyle.largeLabel}
      style={radioButtonStyle.button}
      value="text"
    />
  </RadioButtonGroup>
)

EmailTextFilter.propTypes = {
  handleRadioBtnSelect: PropTypes.func.isRequired,
  radioDisabled: PropTypes.bool.isRequired,
  selectedRadioBtn: PropTypes.string.isRequired,
}
export default EmailTextFilter



// WEBPACK FOOTER //
// ./src/components/Messages/MessagesFilter/EmailTextFilter.js